  (function () {
    function hideJudgeMeCounts() {
      document.querySelectorAll('[data-product-grid] .jdgm-preview-badge').forEach(function (badge) {
        badge.querySelectorAll('.jdgm-prev-badge__text').forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('width', '0', 'important');
          el.style.setProperty('margin', '0', 'important');
          el.style.setProperty('padding', '0', 'important');
          el.textContent = '';
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      hideJudgeMeCounts();

      setTimeout(hideJudgeMeCounts, 500);
      setTimeout(hideJudgeMeCounts, 1500);

      const observer = new MutationObserver(function () {
        hideJudgeMeCounts();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  })();
